import cloudbase from "@cloudbase/js-sdk";
import router from '../router'
import { Message, Notice } from 'view-design'
const cloudapp = cloudbase.init({
    // env: 'dev-ocdu6',
    env: 'am9pm4-3gwl8k29897cf4cc',

});
// 测试2

cloudapp.auth().signInAnonymously()

const app = (name, func, data) => {
    data.token = localStorage.getItem("firm_token")
    data.mobile = localStorage.getItem("firm_mobile") ? localStorage.getItem("firm_mobile") : data.mobile
    return cloudapp.callFunction({
        name,
        data: {
            func,
            data,
        },
        parse: true
    }).then(res => {
        if (res.result.code != 200) {
            Message.error({
                content: res.result.message,
                closable: true,
                duration: 5
            })
        }
        if (res.result.code == 401 || res.result.code == 404) {
            console.log("登录去");
            router.push('/');
        }
        return res.result



    })
}
const upLoad = (data) => {
    console.log(data);
    return cloudapp.uploadFile(data).then(res => {
        return res
    })
}

export default { app, upLoad, cloudapp }